<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaJudet')}}</h4>
        </div>
        <form class="add-user-form" id='edit-level1' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-county">
                    <button type="button" @click='saveCounties()'>
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CountiesService from '../../api-services/counties.service.js'
export default {
  name: 'editcounty',
  data () {
    return {
      counties: null
    }
  },
  methods: {
    getCounties () {
      CountiesService.get(this.$route.params.id)
        .then((response) => {
          this.counties = response.data.data
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    saveCounties () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-level1'))

      CountiesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.counties = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.judetModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.counties) ? this.counties.name : null,
            icon: 'fas fa-city',
            validationRules: ''
          }
        ]
      }
    }
  },
  created () {
    this.getCounties()
  }
}
</script>
